const ROLE_LABELS: Record<string, string> = {
  ADMIN: 'Administrátor',
  MANAGER: 'Manažer',
  WAREHOUSE: 'Skladník',
  WORKER: 'Pracovník',
  MARKETING: 'Marketing',
  SWITCHBOARD: 'Rozvaděče',
}

/** Název podle starého klíče role — jen záloha, když chybí název role firmy. */
export function getRoleLabel(role: string): string {
  return ROLE_LABELS[role] || role
}

/**
 * Název role uživatele: role firmy (role_info z /admin/users nebo role_name z /auth), jinak záloha
 * podle starého klíče role.
 */
export function roleNameOf(u: { role: string; role_name?: string | null; role_info?: { name: string } | null }): string {
  return u.role_info?.name ?? u.role_name ?? getRoleLabel(u.role)
}
